import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";
import "./Tours-title-ellipsis.css";

export default function MyTours() {
  const navigate = useNavigate();
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FILTER STATE ================= */

  const [filters, setFilters] = useState({
  search: "",
  date: "all"
});

  

  /* ================= LOAD ================= */

  const load = async () => {
    try {
      setLoading(true);

      const res = await API.get("/guide/mine");

      setTours(
        Array.isArray(res.data)
          ? res.data
          : []
      );

    } catch (err) {

      console.error(
        "load my tours error:",
        err
      );

      setTours([]);

    } finally {

      setLoading(false);

    }
  };


const unassignTour = async (sessionId) => {
  const confirmed = window.confirm(
    "Are you sure you want to unassign this tour?"
  );

  if (!confirmed) return;

  try {
    await API.post(`/guide/unassign/${sessionId}`);

    await load();

  } catch (err) {

    console.error("UNASSIGN TOUR ERROR:", err);

    alert(
      err.response?.data?.error ||
      "Unable to unassign tour"
    );
  }
};

  useEffect(() => {
    load();
  }, []);


  /* ================= DATE FORMAT ================= */

  const formatDateTime = (dateString) => {

    if (!dateString) {
      return "No date";
    }

    const date =
      new Date(dateString);

    return date.toLocaleString(
      "en-GB",
      {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      }
    );
  };


  /* ================= FILTER ================= */

  const filteredTours = useMemo(() => {

    return tours.filter((t) => {

      const matchSearch =
        t.title
          ?.toLowerCase()
          .includes(
            filters.search.toLowerCase()
          );

      const now =
        new Date();

      const tourDate =
        new Date(t.start_datetime);

      const matchDate =
        filters.date === "all"
          ? true
          : filters.date === "today"
          ? tourDate.toDateString() ===
            now.toDateString()
          : tourDate >= now;

      return (
        matchSearch &&
        matchDate
      );

    });

  }, [tours, filters]);


 

  /* ================= RENDER ================= */

  return (
    <div style={page}>

      {/* HEADER */}

      <div style={header}>

        <h2 style={title}>
          My Assigned Tours
        </h2>

        <p style={subtitle}>
          Your upcoming guided experiences
        </p>

      </div>


      {/* FILTERS */}

      <div style={filterBar}>

        <input
          placeholder="Search tours..."
          value={filters.search}
          onChange={(e) =>
            setFilters((p) => ({
              ...p,
              search: e.target.value
            }))
          }
          style={input}
        />

        <select
          value={filters.date}
          onChange={(e) =>
            setFilters((p) => ({
              ...p,
              date: e.target.value
            }))
          }
          style={select}
        >

          <option value="upcoming">
            Upcoming
          </option>

          <option value="today">
            Today
          </option>

          <option value="all">
            All
          </option>

        </select>

        <button
          onClick={load}
          style={refreshBtn}
        >
          Refresh
        </button>

      </div>


      {/* LOADING */}

      {loading && (
        <div style={loadingBox}>
          Loading...
        </div>
      )}


      {/* EMPTY */}

      {!loading &&
        filteredTours.length === 0 && (
          <div style={emptyBox}>
            No tours found
          </div>
        )}


      {/* GRID */}

      <div style={grid}>

        {filteredTours.map((t) => {

          const booked =
            t.booked ?? 0;

          const capacity =
            t.capacity ?? 0;

          const fillPercent =
            capacity > 0
              ? Math.round(
                  (booked / capacity) * 100
                )
              : 0;

          return (

           <div
              key={t.id}
              style={card}
              onClick={() => navigate(`/guide/tour/${t.id}`)}
            >
              <div style={cardHeader}>
                <h3 title={t.title} style={tourTitle}>{t.title}</h3>
                <span
                  style={{
                    ...badge,
                    ...(fillPercent >= 100
                      ? fullBadge
                      : fillPercent >= 80
                      ? busyBadge
                      : activeBadge)
                  }}
                >
                  {fillPercent >= 100 ? "Full" : fillPercent >= 80 ? "Busy" : "Open"}
                </span>
              </div>

              <div style={detailItem}>
                <span style={detailIcon}>▦</span>
                <div style={{ minWidth: 0 }}>
                  <div style={detailLabel}>DATE & TIME</div>
                  <div style={detailValue}>{formatDateTime(t.start_datetime)}</div>
                </div>
              </div>

              <div style={guestSection}>
                <div style={guestHeader}>
                  <div>
                    <div style={detailLabel}>GUESTS</div>
                    <strong style={guestCount}>{booked}/{capacity}</strong>
                  </div>
                  <span style={percentText}>{fillPercent}% filled</span>
                </div>
                <div style={barBg}>
                  <div
                    style={{
                      ...barFill,
                      width: `${Math.min(fillPercent, 100)}%`,
                      background: fillPercent >= 100 ? "#ef4444" : fillPercent >= 80 ? "#f59e0b" : "#22c55e"
                    }}
                  />
                </div>
              </div>

              <div style={rateRow}>
                <span>Your rate</span>
                <strong>
                  {new Intl.NumberFormat("en-IE", {
                    style: "currency",
                    currency: "EUR"
                  }).format(Number(t.guide_rate ?? 0))}
                </strong>
              </div>

              {Number(booked) === 0 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    unassignTour(t.id);
                  }}
                  style={unassignBtn}
                >
                  ↩ Unassign Tour
                </button>
              )}
            </div>

          );

        })}

      </div>


    

      

    </div>
  );
}


/* ================= STYLES ================= */

const page = {
  padding: 24,
  background: "#f5f6f8",
  minHeight: "100vh",
  boxSizing: "border-box",
  color: "#172033"
};

const header = {
  marginBottom: 20
};

const title = {
  margin: 0,
  fontSize: 28,
  lineHeight: 1.2,
  fontWeight: 750,
  color: "#111827",
  letterSpacing: "-0.5px"
};

const subtitle = {
  marginTop: 6,
  marginBottom: 0,
  fontSize: 14,
  color: "#718096"
};

const filterBar = {
  display: "grid",
  gridTemplateColumns: "minmax(220px, 1fr) minmax(150px, 220px) auto",
  alignItems: "center",
  gap: 12,
  padding: 16,
  marginBottom: 22,
  background: "#ffffff",
  border: "1px solid #dce2e9",
  borderRadius: 11,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)"
};

const input = {
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d5dce5",
  background: "#ffffff",
  color: "#263247",
  fontSize: 13,
  outlineColor: "#c75028"
};

const select = {
  ...input,
  maxWidth: "100%"
};

const refreshBtn = {
  minHeight: 40,
  padding: "10px 16px",
  borderRadius: 8,
  border: "none",
  background: "#c75028",
  color: "#ffffff",
  fontSize: 13,
  fontWeight: 650,
  cursor: "pointer",
  whiteSpace: "nowrap"
};

const loadingBox = {
  padding: 22,
  background: "#ffffff",
  borderRadius: 11,
  border: "1px solid #dce2e9",
  color: "#718096",
  marginBottom: 16
};

const emptyBox = {
  padding: 34,
  textAlign: "center",
  background: "#ffffff",
  borderRadius: 11,
  border: "1px solid #dce2e9",
  color: "#718096"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 360px), 1fr))",
  gap: 16,
  alignItems: "start"
};

const card = {
  minWidth: 0,
  boxSizing: "border-box",
  background: "#ffffff",
  borderRadius: 11,
  padding: 18,
  border: "1px solid #dce2e9",
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)",
  cursor: "pointer",
  transition: "box-shadow .15s ease, border-color .15s ease",
  WebkitTapHighlightColor: "transparent"
};

const cardHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 10,
  paddingBottom: 13,
  marginBottom: 13,
  borderBottom: "1px solid #e8edf2"
};

const tourTitle = {
  minWidth: 0,
  margin: 0,
  fontSize: 16,
  lineHeight: 1.35,
  fontWeight: 700,
  color: "#172033",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: "1 1 0"
};

const badge = {
  flexShrink: 0,
  fontSize: 11,
  fontWeight: 650,
  padding: "5px 10px",
  borderRadius: 999,
  lineHeight: 1,
  whiteSpace: "nowrap"
};

const activeBadge = {
  background: "#ecfdf3",
  border: "1px solid #b7ebc8",
  color: "#16834a"
};

const busyBadge = {
  background: "#fff7e8",
  border: "1px solid #f5d59a",
  color: "#a56608"
};

const fullBadge = {
  background: "#fff1f0",
  border: "1px solid #f4c7c3",
  color: "#c24136"
};

const detailItem = {
  display: "flex",
  alignItems: "center",
  gap: 11,
  minWidth: 0,
  marginTop: 2
};

const detailIcon = {
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  width: 28,
  height: 28,
  borderRadius: 8,
  background: "#fff3ed",
  color: "#c75028",
  fontSize: 15
};

const detailLabel = {
  marginBottom: 3,
  fontSize: 10,
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: ".06em",
  color: "#8792a2"
};

const detailValue = {
  fontSize: 13,
  lineHeight: 1.4,
  fontWeight: 650,
  color: "#263247",
  overflowWrap: "anywhere"
};

const guestSection = {
  marginTop: 15,
  paddingTop: 13,
  borderTop: "1px solid #e8edf2"
};

const guestHeader = {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: 10
};

const guestCount = {
  display: "block",
  fontSize: 17,
  lineHeight: 1.2,
  color: "#172033"
};

const infoRow = {
  minWidth: 0,
  fontSize: 13,
  lineHeight: 1.45,
  fontWeight: 550,
  color: "#263247",
  marginTop: 8,
  overflowWrap: "anywhere"
};

const rateRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  marginTop: 12,
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #f0d5c9",
  background: "#fff7f2",
  color: "#7c3b27",
  fontSize: 13
};

const barBg = {
  height: 7,
  background: "#edf0f3",
  borderRadius: 999,
  overflow: "hidden",
  marginTop: 10
};

const barFill = {
  height: "100%",
  borderRadius: 999,
  transition: "width .2s ease"
};

const percentText = {
  fontSize: 12,
  marginTop: 0,
  marginBottom: 2,
  color: "#718096",
  textAlign: "right",
  whiteSpace: "nowrap"
};

const unassignBtn = {
  marginTop: 12,
  width: "100%",
  boxSizing: "border-box",
  padding: "9px 12px",
  borderRadius: 8,
  border: "1px solid #f0c9c5",
  background: "#fff7f5",
  color: "#b74632",
  fontSize: 13,
  fontWeight: 650,
  cursor: "pointer"
};

